const ContactS2 = () => {
  return (
    <div className="contact_s2">
      <div className="article_container">
        <div className="article">
          <img src="/images/map.jpg" alt="" />
        </div>
        <div className="article">
          <div className="article_box article_box1">
            <a
              href="https://map.naver.com/p/search/%EB%8C%80%EA%B5%AC%EA%B4%91%EC%97%AD%EC%8B%9C%20%EB%8F%99%EA%B5%AC%20%EA%B2%BD%EC%95%88%EB%A1%9C%20722/address/14328361.8319105,4282270.1433382,%EB%8C%80%EA%B5%AC%EA%B4%91%EC%97%AD%EC%8B%9C%20%EB%8F%99%EA%B5%AC%20%EA%B2%BD%EC%95%88%EB%A1%9C%20722,new?c=19.00,0,0,0,dh&isCorrectAnswer=true"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/images/portfolio_s2_icon1.png" alt="" />
            </a>
            <p>찾아오시는 길</p>
            <p>
              대구광역시 동구 경안로 722
              <br />
              3층 STUDIOFROG
            </p>
            <p>주차가능 "방문 전 연락 부탁드립니다."</p>
          </div>
        </div>
        <div className="article">
          <div className="article_box">
            <img src="/images/portfolio_s2_icon2.png" alt="" />
            <p>전화</p>
            <p>010-7747-5367</p>
          </div>
        </div>
        <div className="article">
          <div className="article_box">
            <a
              href="https://www.instagram.com/film_pond_house/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/images/portfolio_s2_icon3.png" alt="" />
            </a>
            <p>인스타그램</p>
            <p>film_pond_house</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactS2;
